import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CreditCheckOrgUser from './CreditCheckOrgUser';

/**
 * CreditCheckWithoutOTP Component
 * 
 * This component is for credit checks WITHOUT OTP verification.
 * 
 * Plans available:
 * - Basic: LCS Report & PAN Verification
 * - Advanced: Basic + Credit Bureau API (CIBIL/CRIF/Experian) WITHOUT OTP - Instant
 * - Combo: Basic + Advanced + Court Case verification
 * 
 * Uses IDS Pay API for instant CIBIL/CRIF/Experian credit reports.
 */
export default function CreditCheckWithoutOTP() {
  const location = useLocation();
  const [selectedPlan, setSelectedPlan] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const plan = params.get('plan');
    if (plan) {
      // Capitalize first letter for plan type
      const planType = plan.charAt(0).toUpperCase() + plan.slice(1);
      setSelectedPlan(planType);
    } else {
      setSelectedPlan(null);
    }
  }, [location.search]);

  return <CreditCheckOrgUser mode="without-otp" selectedPlan={selectedPlan} />;
}
